import { gql } from '@apollo/client';

export const ALL_PORTAL_COHORTS = gql`
  query AllPortalCohorts($input: CohortFilterArgs!) {
    cohorts: getPortalCohorts(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          createdAt
          updatedAt

          description
          name

          # computed
          beneficiariesCount
          institutionsCount
          peopleCount

          intervention {
            id
            name
          }
          ownerOrganisation {
            id
            funder {
              id
              name
            }
            institution {
              id
              name
            }
            serviceProvider {
              id
              name
            }
          }
        }
      }
    }
  }
`;
